import { render, staticRenderFns } from "./resetPassword.vue?vue&type=template&id=13aa8300&scoped=true&"
import script from "./resetPassword.vue?vue&type=script&lang=js&"
export * from "./resetPassword.vue?vue&type=script&lang=js&"
import style0 from "./resetPassword.vue?vue&type=style&index=0&id=13aa8300&prod&scoped=true&lang=less&"
import style1 from "./resetPassword.vue?vue&type=style&index=1&id=13aa8300&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13aa8300",
  null
  
)

export default component.exports